import styled from 'styled-components';

export const ListContainer = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
`;

export const ListItems = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DivCentral = styled.div`
  line-height: 10rem;
`;
